import Index from './components/Index.vue';
import Category from './components/library/Category.vue';
import Update from './components/library/Update.vue';
import Rookie from './components/library/Rookie.vue';
import RookieStat from './components/library/RookieStat.vue';
import Carousel from './components/library/Carousel.vue';
import LibraryView from './components/library/View.vue';
import Daily from './components/discovery/Daily.vue';
import Score from './components/Score.vue';
import Metric from './components/Metric.vue';
import Collection from "./components/discovery/Collection.vue";
import CollectionEvent from './components/discovery/CollectionEvent.vue';
import Jigsaw from './components/discovery/Jigsaw.vue';
import DiscoveryView from './components/discovery/View.vue';
import Chosen from './components/library/Chosen.vue';
import Scene from './components/homeland/Scene.vue';
import Config from './components/Config.vue';
import CreateGallery from './components/create/Gallery.vue';
import Bonus from './components/library/Bonus.vue';

export const routes = [
    {
        name: 'Index',
        path: '/',
        component: Index,
    }, {
        name: 'Category',
        path: '/category',
        component: Category,
    }, {
        name: 'Daily',
        path: '/daily',
        component: Daily,
    }, {
        name: 'Update',
        path: '/update',
        component: Update,
    }, {
        name: 'Rookie',
        path: '/rookie',
        component: Rookie,
    }, {
        name: 'RookieStat',
        path: '/rookie/stat',
        component: RookieStat,
    }, {
        name: 'LibraryView',
        path: '/library',
        component: LibraryView,
    }, {
        name: 'Carousel',
        path: '/carousel',
        component: Carousel,
    }, {
        name: 'Score',
        path: '/score',
        component: Score,
    }, {
        name: 'Metric',
        path: '/metric',
        component: Metric,
    }, {
        name: 'Collection',
        path: '/collection',
        component: Collection,
    }, {
        name: 'Jigsaw',
        path: '/jigsaw',
        component: Jigsaw,
    }, {
        name: 'DiscoveryView',
        path: '/discovery',
        component: DiscoveryView,
    }, {
        name: 'Chosen',
        path: '/chosen',
        component: Chosen,
    }, {
        name: 'Scene',
        path: '/Scene',
        component: Scene,
    }, {
        name: 'CollectionEvent',
        path: '/collection-event',
        component: CollectionEvent,
    }, {
        name: 'Config',
        path: '/config',
        component: Config,
    }, {
        name: 'CreateGallery',
        path: '/create/gallery',
        component: CreateGallery,
    }, {
        name: 'Bonus',
        path: '/bonus',
        component: Bonus,
    },
]